import { Filter } from 'types/filters';

const filtersKeyMap: Record<string, string> = {
    createdDates: 'created_at',
    updatedDates: 'updated_at',
    deleted: 'deleted',
    isOther: 'is_other',
    chapter: 'chapter',
    type: 'type',
    status: 'status',
    crms: 'crms',
    query: 'query',
    statusId: 'status_key',
};

export const normalizeSort = (sort: {
    sortDirection: Filter['sortDirection'];
    sortBy: Filter['sortBy'];
}) => {
    const normalized = {
        sort_by: sort.sortBy,
        sort_direction: sort.sortDirection,
    };
    return normalized;
};

export const normalizeFilter = (
    filter: Omit<Filter, 'sortDirection' | 'query'>
): Record<string, any> => {
    const isEmptyValue = (val: any): boolean => {
        if (val == null) return true;
        if (Array.isArray(val)) {
            return val.every((item) => item === '' || item == null);
        }
        return false;
    };
    const normalized: Record<string, any> = {};

    for (const [key, value] of Object.entries(filter)) {
        if (isEmptyValue(value)) continue;

        if (key === 'eventDates' && Array.isArray(value)) {
            if (value[0]) normalized['event_date'] = value[0];
            if (value[1]) normalized['end_date'] = value[1];
            continue;
        }

        const snakeKey = filtersKeyMap[key];
        if (!snakeKey) continue;
        normalized[snakeKey] = value;
    }

    return normalized;
};
